<template>
  <div class="badlist-create">
    <SidebarLayout2 :breadcrumb="breadcrumb" class="badlist-create--sidebar">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="badlist-create--sidebar">
          <PmwHeading size="paragraph-40">Ações da página</PmwHeading>
          <!-- BOTÕES DE AÇÃO -->
          <div>
            <PmwButton
              :disabled="isDisabled"
              variation="blue-100"
              class="sidebar--button"
              @click="badListId === null ? saveBadList() : editBadlist()"
            >
              {{ badListId ? 'Salvar alterações' : 'Incluir na badlist' }}
            </PmwButton>
            <PmwButton
              v-if="badListId"
              variation="blue-100"
              class="sidebar--button"
              @click="statusGuest ? (showModal = true) : lockSelectedUser()"
            >
              {{ statusGuest ? 'Desbloquear' : 'Bloquear' }}
            </PmwButton>
            <PmwButton
              :link="'/badlist'"
              element="router-link"
              variation="blue-100"
              class="sidebar--button"
            >
              Voltar
            </PmwButton>
          </div>
        </SidebarBlock>
        <!-- DICAS -->
        <SidebarBlock class="badlist-create--advice">
          <PmwHeading size="paragraph-40"> Dica </PmwHeading>
          <PmwParagraph class="advice--paragraph">
            A descrição do motivo do bloqueio facilita na encontrabilidade
            posterior dos hóspedes bloqueados.
          </PmwParagraph>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <PmwTitleWithLine
          title="Cadastrar hóspede na Badlist"
          description=""
          class="badlist-create--title"
        />
        <div class="badlist-create--container-input">
          <PmwFormSelect
            v-model="documentType"
            :options="documentTypeOptions"
            :required="true"
            :disabled="attempts > 0"
            label="Dado do hóspede"
            placeholder="Selecione"
            class="input-container--select"
            @input="inputValue = ''"
          />
          <!-- CPF -->
          <PmwFormInput
            v-if="documentType.value === 'cpf'"
            v-model="inputValue"
            :key="`input-${documentType.value}`"
            :required="true"
            :hasMask="true"
            :mask="'###.###.###-##'"
            :maxlength="100"
            :error="inputValue.length > 3 && inputValue.length < 14"
            :showErrorFeedbackMessage="true"
            :feedbackMessage="'CPF Incompleto'"
            :disabled="attempts > 0"
            label="Digite o CPF do hóspede"
            placeholder=""
            class="input-container--input-text"
          />

          <!-- EMAIL -->
          <PmwFormInput
            v-if="documentType.value === 'email'"
            v-model="inputValue"
            :key="`input-${documentType.value}`"
            :required="true"
            :maxlength="100"
            :disabled="attempts > 0"
            :error="!isEmailValid(inputValue)"
            :showErrorFeedbackMessage="true"
            :feedbackMessage="'E-mail inválido'"
            label="Digite o E-mail do hóspede"
            placeholder=""
            class="input-container--input-text"
          />
          <!-- PASSAPORTE -->
          <PmwFormInput
            v-if="documentType.value === 'passaport'"
            v-only-alphaNumeric
            v-model="inputValue"
            :key="`input-${documentType.value}`"
            :error="!isPassaportValid(inputValue)"
            :showErrorFeedbackMessage="true"
            :feedbackMessage="'Caractere inválido'"
            :required="true"
            :maxlength="100"
            :disabled="attempts > 0"
            label="Digite o passaporte do hóspede"
            placeholder=""
            class="input-container--input-text"
          />
        </div>
        <Textarea
          v-model="summaryBlock"
          :counter="true"
          :maxlength="500"
          :row="10"
          :required="true"
          :error="motivoTouched && !summaryBlock"
          :showErrorFeedbackMessage="true"
          feedbackMessage="Preencha o motivo do bloqueio"
          label="Descreva o motivo do bloqueio"
          placeholder="Descreva resumidademente o motivo do bloqueio"
          class="badlist-create--description"
          @blur="motivoTouched = true"
        />
        <InfoPanel height="62" class="badlist-create--info-panel">
          <template #content>
            <PmwParagraph size="paragraph-40">
              O motivo completo e detalhes específicos do bloqueio são de
              responsabilidade do hotel de armazenamento e gestão.
            </PmwParagraph>
          </template>
        </InfoPanel>
        <div class="badlist-create--input-area">
          <PmwButton
            :link="'/badlist'"
            element="router-link"
            size="fluid"
            layout="outline"
            variation="blue-100"
            class="action-area--button"
          >
            Voltar sem salvar
          </PmwButton>
          <PmwButton
            :disabled="isDisabled"
            size="fluid"
            variation="blue-100"
            class="action-area--button"
            @click="badListId === null ? saveBadList() : editBadlist()"
          >
            {{ badListId ? 'Editar badlist' : 'Registrar na badlist' }}
          </PmwButton>
        </div>
        <!-- MODAL DE CONFIRMAÇÃO -->
        <PmwAlertModal
          v-model="showModal"
          :title="''"
          closeButton
          icon="lock-open"
          cancelButtonText="Voltar"
          confirmButtonText="Desbloquear"
          confirmButtonColor="blue-100"
          @alert-modal-confirm="deleteBadlist"
          @alert-modal-cancel="showModal = false"
        >
          <template #text>
            <div class="modal--container-content">
              <PmwHeading class="modal--title">Desbloquear hóspede</PmwHeading>
              <PmwParagraph size="paragraph-60" class="modal--paragraph">
                Ao desbloquear o hóspede, ele poderá efetuar reservas novamente.
              </PmwParagraph>
            </div>
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwTitleWithLine from '@solucoes/components-lib-tmp/src/components/elements/PmwTitleWithLine'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import { validateEmail } from '@/helpers/string'

import OnlyAlphaNumericDirective from '@/directives/OnlyAlphaNumericDirective'

export default {
  name: 'CreatebadList',

  directives: {
    'only-alphaNumeric': OnlyAlphaNumericDirective
  },

  components: {
    SidebarLayout2,
    SidebarBlock,
    PmwHeading,
    PmwButton,
    PmwParagraph,
    PmwTitleWithLine,
    PmwFormSelect,
    Textarea,
    InfoPanel,
    PmwFormInput,
    PmwAlertModal
  },

  data() {
    return {
      /** Configuração da página */
      pageTitle: 'Cadastrar hóspede na Badlist',
      /** Caminhos da página */
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Badlist',
          url: '/badlist',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Incluir na badlist',
          url: '/badlist/create',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],
      documentTypeOptions: [
        { text: 'E-mail', value: 'email' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Passaporte', value: 'passaport' }
      ],
      documentType: '',
      summaryBlock: '',
      inputValue: '',
      badListId: null,
      showModal: false,
      statusGuest: null,
      attempts: 0,
      motivoTouched: false
    }
  },

  async created() {
    /** Se for edição, pegar o ID e o fornecedor */
    this.badListId = this.$route.params.id || null
    await this.getBadlistById()
  },

  computed: {
    isCpfInvalid() {
      return this.documentType?.value === 'cpf' && this.inputValue.length !== 14
    },

    isEmailInvalid() {
      return (
        this.documentType?.value === 'email' &&
        !this.isEmailValid(this.inputValue)
      )
    },

    isPassaportInvalid() {
      return (
        this.documentType?.value === 'passaport' &&
        !this.isPassaportValid(this.inputValue)
      )
    },

    isDisabled() {
      return (
        !this.documentType ||
        !this.inputValue ||
        !this.summaryBlock ||
        this.isEmailInvalid ||
        this.isPassaportInvalid ||
        this.isCpfInvalid
      )
    }
  },

  methods: {
    /**
     * Valida Passaporte com regex (Exemplo de formato genérico)
     * @param {String} passport: passaporte a ser validado
     */
    isPassaportValid(passport) {
      const passportRegex = /^[A-Za-z0-9]*$/
      return passportRegex.test(passport)
    },

    /**
     * Valida email
     * @param {String} email: email a ser validado
     */
    isEmailValid(email) {
      return validateEmail(email)
    },

    /**
     * Bloqueia o usuário da lista
     * @param {Object} selectedUser: Objeto representa usuario clicado
     */
    lockSelectedUser() {
      this.$badlist
        .updateUserBadlist({
          codigo: parseInt(this.badListId),
          tipo: this.documentType.value,
          valor: this.inputValue,
          ativo: true,
          motivo: this.summaryBlock
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Hóspede bloqueado com sucesso!'
          })

          this.$router.push({
            path: '/badlist'
          })
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Hóspede já existe na badlist'
            })
          } else {
            this.$bus.$emit('show-alert-chip', {
              message: 'Erro ao bloquear hóspede'
            })
          }
        })
    },

    deleteBadlist() {
      const dataDelete = parseInt(this.badListId)
      this.$badlist.deleteUserBadList(dataDelete).then(() => {
        this.showModal = false
        this.$router.push({
          path: '/badlist'
        })
        /** Feedback */
        this.$bus.$emit('show-alert-chip', {
          message: 'Hóspede Bloqueado com sucesso!'
        })
      })
    },

    editBadlist() {
      const dataUpdate = {
        codigo: parseInt(this.badListId),
        tipo: this.documentType.value,
        valor: this.inputValue,
        ativo: this.statusGuest,
        motivo: this.summaryBlock
      }
      this.$badlist
        .updateUserBadlist(dataUpdate)
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Hóspede editado com sucesso!'
          })
          /** Redirecionar para a listagem de grupos de usuários */
          setTimeout(() => {
            this.$router.push({
              path: '/badlist'
            })
          }, 1000)
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Hóspede já existe na badlist'
            })
          } else {
            this.$bus.$emit('show-alert-chip', {
              message: 'Erro ao editar hóspede'
            })
          }
        })
    },

    saveBadList() {
      this.motivoTouched = true
      if (!this.documentType || !this.inputValue || !this.summaryBlock) {
        this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios.'
        })
        return
      }

      this.$badlist
        .insertUserBadlist({
          tipo: this.documentType.value,
          valor: this.inputValue,
          motivo: this.summaryBlock
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Hóspede bloqueado com sucesso!'
          })

          this.$router.push('/badlist')
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Hóspede já existe na badlist'
            })
          } else {
            this.$bus.$emit('show-alert-chip', {
              message: 'Erro ao bloquear hóspede'
            })
          }
        })
    },

    async getBadlistById() {
      if (this.badListId !== null) {
        await this.$badlist
          .getBadlistById(this.badListId)
          .then((response) => {
            const docType = this.documentTypeOptions.find(
              (e) => e.value === response.data.tipo.trim().toLowerCase()
            )
            this.attempts = response.data.tentativas
            this.documentType = docType
            this.inputValue = response.data.valor
            this.summaryBlock = response.data.motivo
            this.statusGuest = response.data.ativo
          })
          .catch(() => {
            this.$bus.$emit('show-alert-chip', {
              message: 'Erro ao buscar hóspede'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.badlist-create {
  &--title {
    color: $blue;
    margin: 0px auto;
  }
  .sidebar {
    &--button {
      margin-bottom: 6px;
    }
  }

  &--input-area {
    margin-top: 34px;
    display: flex;
    justify-content: space-between;
  }
  .action-area {
    &--button {
      width: 215px !important;
    }
  }

  .advice {
    &--paragraph {
      line-height: 21px;
    }
  }

  &--info-panel {
    margin-top: 40px;
    max-width: 494px;
    background-color: #fef8cd;
    color: #fa8425;
    align-content: center;
    ::v-deep .pmw-paragraph {
      color: #fa8425;
      font-size: font-size('size-small');
      line-height: 21px;
      text-align: left;
    }
  }

  &--container-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 58px;

    .input-container {
      ::v-deep input {
        background-color: $white;
      }

      &--select {
        margin: 65px 0px;
        max-width: 173px;
        ::v-deep button {
          padding: 0px;
          span {
            color: $gray-darkest;
          }
        }
      }
      &--input-text {
        max-width: 396px;
      }
    }
  }
}
.modal {
  &--img {
    margin-top: -50px;
    margin-bottom: 20px;
  }
}
</style>
